import Builder from '@/Builder/Builder';

export default abstract class SimpleElementBuilder extends Builder<null, null> {

    protected constructor() {
        super();
    }

    protected element: HTMLElement;

    protected locator: string;

    public withLocator(locator: string): this {
        this.locator = locator;
        return this;
    }

    public withElement(element: HTMLElement): this {
        this.element = element;
        return this;
    }

    protected preBuild(): void {
        return;
    }

    protected buildInternal(): null {
        return null;
    }

    public abstract buildAndGetElement(): HTMLElement;
}